export default {
  "b2b.projekty-grid-columns.nazev.label": "Name",
  "b2b.projekty-grid-columns.popis.label": "Description",
  "b2b.projekty-grid-columns.smlouva.label": "Contract",
  "b2b.projekty-grid-columns.vytvoril.label": "Created by",
  "b2b.projekty-grid-columns.upravil.label": "Last modified by",
  "b2b.projekty-grid-columns.datumUprava.label": "Last modified date",
  "b2b.projekty-grid-columns.datumVytvoreni.label": "Created date"
};
